import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {fetchCourses} from "../../service/courses/fetchCourses";
import {Course, CourseData} from "../../types/courses/Courses";

const coursesSlice = createSlice({
    name: "courses",
    initialState: {
        courseData: {} as CourseData,
        isLoading: false,
        error: null,
    },
    reducers: {
        setCourseData: (state, action: PayloadAction<CourseData>) => {
            state.courseData = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCourses.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchCourses.fulfilled, (state, action) => {
                state.isLoading = false;
                state.courseData = action.payload.data;
                state.error = null;
            })
            .addCase(fetchCourses.rejected, (state, action) => {
                state.isLoading = false;
                // @ts-ignore
                state.error = action.payload;
            });
    },
});

export const { setCourseData, setLoading } = coursesSlice.actions;
export const coursesReducer = coursesSlice.reducer;